import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import PageBanner from "@/components/PageBanner";
import { Waves, Mountain, Compass, Map } from "lucide-react";

const features = [
  {
    icon: Waves,
    title: "Water Adventures",
    description: "1,200 km² of water surface on Lake Victoria, perfect for kayaking and canoeing"
  },
  {
    icon: Mountain,
    title: "White Water Rafting",
    description: "7 meters of whitewater rapids on the Nile River in Jinja, Uganda"
  },
  {
    icon: Compass,
    title: "Mountain Hiking",
    description: "5,109 meters of hiking trails in the Rwenzori Mountains, Uganda"
  },
  {
    icon: Map,
    title: "Regional Exploration",
    description: "Explore the Mount Kenya National Park, the Kilimanjaro National Park in Tanzania, and the Mount Bisoke volcano in Rwanda"
  }
];

export default function AdventureActivities() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>Soft & Extreme Adventure Activities | Ecoplace Tours</title>
        <meta
          name="description"
          content="Experience East Africa's thrilling adventures with our expert guides through the region's most breathtaking landscapes."
        />
      </Helmet>

      <PageBanner
        title="Soft & Extreme Adventure Activities"
        description="Experience East Africa's thrilling adventures with our expert guides, who will lead you through the region's most breathtaking landscapes."
        backgroundImage="/kayaking.png"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className="bg-white rounded-xl shadow-lg p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="p-3 bg-primary/10 rounded-lg">
                  <feature.icon className="w-6 h-6 text-primary" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900">
                  {feature.title}
                </h3>
              </div>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            From thrilling water sports to challenging mountain treks, our experienced guides ensure your safety while maximizing your adventure experience across East Africa's diverse landscapes.
          </p>
        </motion.div>
      </div>
    </div>
  );
}
